import type { CustomIconProps } from '../CustomIcon';

export const ClearCircleIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => (
  <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M12 22.2767C17.5228 22.2767 22 17.7996 22 12.2767C22 6.75389 17.5228 2.27673 12 2.27673C6.47715 2.27673 2 6.75389 2 12.2767C2 17.7996 6.47715 22.2767 12 22.2767Z'
      fill={color}
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15 9.27673L9 15.2767'
      stroke={secondaryColor}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9 9.27673L15 15.2767'
      stroke={secondaryColor}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
